import { SVGProps } from 'react'

export const PPTXIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
      fill="#E62E05"
    />
    <path
      opacity="0.3"
      d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z"
      fill="white"
    />
    <path
      d="M8.51909 32V25.4545H11.1015C11.5979 25.4545 12.0209 25.5494 12.3703 25.739C12.7197 25.9265 12.9861 26.1875 13.1693 26.522C13.3547 26.8544 13.4474 27.2379 13.4474 27.6726C13.4474 28.1072 13.3536 28.4908 13.1661 28.8232C12.9786 29.1555 12.7069 29.4144 12.3511 29.5998C11.9974 29.7852 11.5692 29.8778 11.0663 29.8778H9.42037V28.7688H10.8426C11.1089 28.7688 11.3284 28.723 11.501 28.6314C11.6757 28.5376 11.8057 28.4087 11.8909 28.2447C11.9782 28.0785 12.0219 27.8878 12.0219 27.6726C12.0219 27.4553 11.9782 27.2656 11.8909 27.1037C11.8057 26.9396 11.6757 26.8129 11.501 26.7234C11.3263 26.6317 11.1047 26.5859 10.8362 26.5859H9.90297V32H8.51909ZM14.3462 32V25.4545H16.9286C17.4251 25.4545 17.848 25.5494 18.1974 25.739C18.5469 25.9265 18.8132 26.1875 18.9964 26.522C19.1818 26.8544 19.2745 27.2379 19.2745 27.6726C19.2745 28.1072 19.1808 28.4908 18.9933 28.8232C18.8058 29.1555 18.5341 29.4144 18.1783 29.5998C17.8246 29.7852 17.3963 29.8778 16.8935 29.8778H15.2475V28.7688H16.6697C16.9361 28.7688 17.1555 28.723 17.3281 28.6314C17.5028 28.5376 17.6328 28.4087 17.718 28.2447C17.8054 28.0785 17.8491 27.8878 17.8491 27.6726C17.8491 27.4553 17.8054 27.2656 17.718 27.1037C17.6328 26.9396 17.5028 26.8129 17.3281 26.7234C17.1534 26.6317 16.9318 26.5859 16.6634 26.5859H15.7301V32H14.3462ZM19.9241 26.5955V25.4545H25.2998V26.5955H23.2959V32H21.928V26.5955H19.9241ZM27.4827 25.4545L28.8026 27.6854H28.8538L30.1801 25.4545H31.743L29.7455 28.7273L31.7877 32H30.1961L28.8538 29.766H28.8026L27.4603 32H25.8751L27.9237 28.7273L25.9134 25.4545H27.4827Z"
      fill="white"
    />
  </svg>
)
